import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';

import './home.css'

const HomeCards = () => {

    return (
        <Fragment>

            <div className='home-cards-div'>
                <div className="home-cards-container">
                    <Link className="home-cards" to='rx-form'>
                        <span className="card-text">New Patients</span>
                        <span className="arrow">➔</span>
                    </Link>

                    <Link className="home-cards" to='midtown-pharmaconnect'>
                        <span className="card-text">Existing Patients</span>
                        <span className="arrow">➔</span>
                    </Link>
                </div>

            </div>

        </Fragment>

    )

};

export default HomeCards;